import { GenverseTokenType } from '../../../types';

export default (token: GenverseTokenType) =>
    !!token &&
    (token?.PK
        ? token.PK
        : `${token?.chain}#${token?.tokenAddress}#${token?.tokenId}`);
